import { BaseError } from 'wagmi';
export class BigmiProviderNotFoundError extends BaseError {
    constructor() {
        super('`useConfig` must be used within `BigmiProvider`.');
        this.name = 'BigmiProviderNotFoundError';
    }
}
//# sourceMappingURL=context.js.map